module.exports = __webpack_public_path__ + "img/singapore.50b9285b.svg";